import { ResponsiveSSRPage } from "@snapchat/web-frame";
import { Reason } from "@snapchat/web-no-content-page";
import { NotFound } from "../components/NotFound";
export default function Error() {
    return (<ResponsiveSSRPage>
      <NotFound reason={Reason.ERROR_OCCURED}/>
    </ResponsiveSSRPage>);
}
